export const PURCHASE_CONTEXT_KEY = "purchase_context";

export const getPurchaseContext = (): object | undefined => {
  try {
    const rawValue = sessionStorage.getItem(PURCHASE_CONTEXT_KEY);
    return rawValue ? JSON.parse(rawValue) : undefined;
  } catch (e) {
    return undefined;
  }
};
